import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthManagerService } from '../../../services/auth/auth-manager.service';
import { AuthenticatedUser } from '../../../services/auth/authenticated-user.model';
import { LocationManagerService } from '../../../services/location/location-manager.service';
import { Location } from '../../../services/location/location.model';
import { MenuItem, MessageService } from 'primeng/api';
import { DeviceManagerService } from '../../../core/services/device-manager.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UiUtils } from 'src/app/shared-ui/utils/ui-utils';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';


@UntilDestroy()
@Component({
    selector: 'ls-location-toolbar',
    templateUrl: './location-toolbar.component.html',
    styleUrls: [ './location-toolbar.component.less' ]
})
export class LocationToolbarComponent implements OnInit, OnDestroy
{
    @HostBinding('class') get classes(): string { return 'dark'; }

    currentUser: AuthenticatedUser;
    locationItems: MenuItem[];
    addLocationFormVisible: boolean = false;
    addLocationForm: FormGroup
    timeZones: string[] =  UiUtils.timeZones.map(x => x.fullName);

    constructor(public deviceManager: DeviceManagerService,
                public authManager: AuthManagerService,
                private locationManager: LocationManagerService,
                private messageService: MessageService,
                private fb: FormBuilder
            ) { 
                this.addLocationForm = this.fb.group({
                    name: ['', Validators.required],
                    address: ['', Validators.required],
                    city: ['', Validators.required],
                    state: ['', [Validators.required, Validators.maxLength(2)]],
                    zip: ['', Validators.required],
                    poNumberPrefix: [''],
                    latitude: [0],
                    longitude: [0],
                    timeZone: ['']
                })
            }

    ngOnInit(): void
    {
        this.authManager.currentUserChanged.pipe(untilDestroyed(this)).subscribe(user => {
            this.currentUser = user;
            this.locationItems = null;
        });
        this.currentUser = this.authManager.currentUser;
    }

    ngOnDestroy(): void {
        /* Implemented to support untilDestroyed */
    }

    loadMenuItems(): void
    {
        if (this.locationItems != null) return;

        this.locationItems = [ { label: 'Loading locations...', items: [] } ];
        this.locationManager.getLocations(false).subscribe(locations => this.locationItems = locations.map(location =>
        {
            return { label: location.name, command: () => this.locationSelected(location) };
        }));
    }

    private locationSelected(location: Location): void
    {
        if (this.currentUser.locationId === location.id) return;
        this.authManager.loginWithRefreshToken(this.currentUser.subsidiaryId, location.id).subscribe();
    }

    addLocation(){
       if(!this.addLocationForm.valid) {
            this.messageService.add({ 
                severity: 'error', 
                summary: 'Add Location', 
                detail: `Please fill required fields.` 
            });
        }

        this.locationManager.addLocation(this.addLocationForm.value).subscribe(
            (location: Location) => {
                this.locationItems.push({label: location.name, command: () => this.locationSelected(location)})
                this.messageService.add({ 
                    severity: 'success', 
                    summary: 'Add Location', 
                    detail: `Location added succesfuly. Set proper metal prices and processor terms for new location`,
                    life: 6000
                });
            },
            error => {
                this.messageService.add({
                    severity: 'error',
                    summary: `Add Location`,
                    detail: ErrorHandlerService.handleError(this, error, 'addLocation()', false, false)
                });
            }
        )
    }
}
